import React, {
    Component
} from 'react';
import {
    domainUrl
} from '../config/Config';
import {
    UserId
} from '../helpers/User';
import {
    handleCheckbox,
    handleRadio,
    getFormValues,
    allowOnlyNumberInput
} from '../helpers/Fields';
import {
    reactLoader,
    getTokenData,
    getUserData,
    message,
    scrollToTop,
    ObserverEcoachMessage,
    contentResizeLoad,
    showSmallLeftMenu,
    objToSlashString
} from '../helpers/Common';
import {
    runValidation
} from '../helpers/Validation';
import Inputgenerator from '../components/Inputgenerator';
import TimerCountDown from '../components/TimerCountDown';
import SelectLearnerObserver from './partials/SelectLearnerObserver';
import ThanksMessage from './partials/ThanksMessage';
import AssessementViewList from './partials/AssessementViewList';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
const $ = window.$;
export default class EvaluationForm extends Component {
    constructor(props) {
        super(props);
        this.submitObserverandProceed = this.submitObserverandProceed.bind(this);
        this.state = {
            welcomeMessage: "",
            selfWelcomeMessage: "",
            scoringExplanation: "",
            questionName: "",
            questionType: "",
            noOfQuestions: "",
            selfEvaluation: false,
            assesorEvaluation: false,
            timeForCompletion: 0,
            timerSeconds: 0,
            canRate: false,
            canAccessLR: false,
            altText: "",
            agInfo: "",
            questions: [],
            dynamicFormData: "",
            componentStatus: this.props.data.status,
            statusMessage: "",
            AssessementViewData: [],
            showCompletedMessage: false,
            showAssessementTable: false,
            completedAssessment: 0,
            completedEvaluators: [],
            completedEvaluatorNames: '',
            acceptedEvaluators: [],
            notAcceptedEvaluators: [],
            isLearnerAnswered: false,
            ratingText: "",
            rating: "",
            openModal: false,
            relations: []
        };
    }
    getEvaluationForm(data) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "get-evaluation-form", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                mentor: getUserData("mentor", true),
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 0) {
                message(responseJson.message, responseJson.errors, "error");
            } else {
                let assessementTable = responseJson.observerEvaluation || (responseJson.evaluationEcoach === '1'),
                    ratingText, rating, isLearnerAnswered = false,
                    completedAssessment = 0,
                    completedEvaluators = [],
                    completedEvaluatorNames = '',
                    acceptedEvaluators = [],
                    notAcceptedEvaluators = [];
                if (this.props.data.status === "completed" && responseJson.canRate) {
                    ratingText = responseJson.ratingText;
                    rating = responseJson.rating;
                }
                if (responseJson.selfEvaluation) {
                    isLearnerAnswered = responseJson.isLearnerAnswered;
                }
                if (responseJson.assesorEvaluation) {
                    completedAssessment = responseJson.completedAssessment;
                    completedEvaluators = responseJson.completedEvaluators;
                    completedEvaluatorNames = responseJson.completedEvaluatorNames;
                    acceptedEvaluators = responseJson.acceptedEvaluators;
                    notAcceptedEvaluators = responseJson.notAcceptedEvaluators;
                }
                this.setState({
                    welcomeMessage: responseJson.welcomeMessage,
                    selfWelcomeMessage: responseJson.selfWelcomeMessage,
                    scoringExplanation: responseJson.scoringExplanation,
                    questionName: responseJson.questionName,
                    questionType: responseJson.questionType,
                    noOfQuestions: responseJson.noOfQuestions,
                    selfEvaluation: responseJson.selfEvaluation,
                    assesorEvaluation: responseJson.assesorEvaluation,
                    timeForCompletion: responseJson.timeForCompletion,
                    timerSeconds: (responseJson.timeForCompletion * 60),
                    canRate: responseJson.canRate,
                    canAccessLR: responseJson.canAccessLR,
                    agInfo: responseJson.agInfo,
                    altText: responseJson.altText,
                    questions: responseJson.questions,
                    dynamicFormData: responseJson,
                    showAssessementTable: assessementTable,
                    completedAssessment: completedAssessment,
                    completedEvaluators: completedEvaluators,
                    completedEvaluatorNames: completedEvaluatorNames,
                    acceptedEvaluators: acceptedEvaluators,
                    notAcceptedEvaluators: notAcceptedEvaluators,
                    isLearnerAnswered: isLearnerAnswered,
                    ratingText: ratingText,
                    rating: rating,
                    statusMessage: ObserverEcoachMessage({
                        evaluation_mentor: responseJson.evaluationMentor,
                        evaluation_ecoach: responseJson.evaluationEcoach,
                        mentor_perform: responseJson.mentorPerform,
                        ecoach_perform: responseJson.ecoachPerform,
                        mentor_view: responseJson.mentorView,
                        ecoach_view: responseJson.ecoachView
                    })
                });
                if (assessementTable && data.status === "completed") {
                    this.getAssessors();
                }
                setTimeout(() => {
                    contentResizeLoad();
                    showSmallLeftMenu();
                    contentResizeLoad();
                    reactLoader("hide");
                }, 200);
            }
        });
    }
    getAssessors() {
        const {
            data
        } = this.props;
        let query_data = objToSlashString({
            learner_id: UserId(),
            seq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            dlr_id: data.dlr_id,
            comp_id: data.id,
            type: "evaluation_questionaire"
        });
        fetch(domainUrl + "mentor-assess/view" + query_data, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 1) {
                this.setState({
                    AssessementViewData: responseJson.data
                })
            }
        });
    }
    componentDidMount() {
        const {
            data
        } = this.props;
        this.getEvaluationForm(data);
        this.getRelations(getUserData("productID", true));
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.getEvaluationForm(data);
        this.getRelations(getUserData("productID", true));
    }
    submitEvaluationForm() {
        if (runValidation()) {
            let dynamicFormData = getFormValues(this.state.dynamicFormData);
            let rating = this.refs.rating !== undefined ? this.refs.rating.value : 0;
            const {
                data
            } = this.props;
            reactLoader("show");
            fetch(domainUrl + "post-evaluation-form", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    mentor: getUserData("mentor", true),
                    form_data: dynamicFormData,
                    rating: rating,
                    data: data
                })
            }).then((response) => response.json()).then((responseJson) => {
                reactLoader("hide");
                if (responseJson.status === 0) {
                    message(responseJson.message, responseJson.errors, "error");
                } else {
                    scrollToTop();
                    if (responseJson.isCompletedFully) {
                        this.goToThanksPage();
                    } else {
                        let showCompletedMessage = (responseJson.componentStatus === "completed") ? true : false,
                            ratingText = this.state.canRate ? responseJson.ratingText : "",
                            rating = this.state.canRate ? responseJson.rating : "",
                            questions = (responseJson.componentStatus === "completed") ? responseJson.questions : this.state.questions;
                        this.setState({
                            componentStatus: responseJson.componentStatus,
                            showCompletedMessage: showCompletedMessage,
                            questions: questions,
                            ratingText: ratingText,
                            rating: rating
                        })
                    }
                }
            });
        }
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }
    submitObserverandProceed(obj) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "evaluation/observer-proceed", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                form_data: this.state.dynamicFormData,
                observers: obj,
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status === 0) {
                message("OOPS!", "Something went wrong. Please try again later.", "error");
            } else {
                scrollToTop();
                if (responseJson.isCompletedFully) {
                    this.goToThanksPage();
                } else {
                    let ratingText = this.state.canRate ? responseJson.ratingText : "",
                        rating = this.state.canRate ? responseJson.rating : "";
                    this.setState({
                        questions: responseJson.questions,
                        componentStatus: "completed",
                        showCompletedMessage: true,
                        ratingText: ratingText,
                        rating: rating
                    })
                }
            }
        });
    }
    goBackToComponentList() {
        const {
            data
        } = this.props;
        this.props.switchback("component_list", data.learning_room_id, data.dlr_id);
    }
    sendEvaluation() {
        if (runValidation('evaluator-block')) {
            const {
                data
            } = this.props;
            reactLoader("show", "Please wait...");
            fetch(domainUrl + "evaluation/send", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    evaluators: this.refs.evaluators_hidden.value,
                    data: data
                })
            }).then((response) => response.json()).then((responseJson) => {
                reactLoader("hide");
                if (responseJson.status === 0) {
                    message("OOPS!", "Something went wrong. Please try again later.", "error");
                } else {
                    this.setState({
                        completedEvaluators: responseJson.completedEvaluators,
                        acceptedEvaluators: responseJson.acceptedEvaluators
                    })
                   $("#SendEvaluator")[0].reset();
                }
            });
        }
    }
    resendEvaluation(id, assessor_id) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "evaluation/resend", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                assessor_id: assessor_id,
                assessor_eval_id: id,
                learner_id: data.learner_id,
                id: data.id,
                learning_room_id: data.learning_room_id,
                compseq_id: data.compseq_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            message("", responseJson.message, "success");
            this.setState({
                completedEvaluators: responseJson.completedEvaluators
            })
        });
    }
    resendEvaluationNotify() {
        message("", "You can resend it tomorrow.", "info");
    }
    withDrawEvaluation(id, assessor_id) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "evaluation/withdraw", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                assessor_id: assessor_id,
                assessor_eval_id: id,
                learner_id: data.learner_id,
                id: data.id,
                learning_room_id: data.learning_room_id,
                compseq_id: data.compseq_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            message("", responseJson.message, "success");
            this.setState({
                completedEvaluators: responseJson.completedEvaluators,
                acceptedEvaluators: responseJson.acceptedEvaluators
            })
        });
    }
    addEvaluator() {
        if (runValidation('add-evl-block')) {
            const {
                data
            } = this.props;
            reactLoader("show", "Please wait...");
            fetch(domainUrl + "evaluators", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    email: this.refs.email.value,
                    assessor_name: this.refs.assessor_name.value,
                    relationship: this.refs.relationship.value,
                    gender: this.refs.gender_hidden.value,
                    phone: this.refs.phone.value,
                    learner_id: getUserData("id", true),
                    product_name: getUserData("productName", true)
                })
            }).then((response) => response.json()).then((responseJson) => {
                this.getNotAcceptedEvaluators();
                setTimeout(() => {
                    reactLoader("hide");
                    if (responseJson.status === 0) {
                        $("#addEvaluator")[0].reset();
                        message(responseJson.message, responseJson.errors, "error");
                    } else {
                        this.closeEvaluatorModal();
                        message("Success!", "Evaluator has been added successfully.", "success");
                    }
                }, 400);
            });
        }
    }
    getNotAcceptedEvaluators() {
        const {
            data
        } = this.props;
        fetch(domainUrl + "evaluation/get-not-accepted-evaluator-list", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            this.setState({
                notAcceptedEvaluators: responseJson.notAcceptedEvaluators
            })
        });
    }
    removeEvaluator(id) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "evaluators/delete-evaluators", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                learner_id: data.learner_id,
                assessor_id: id
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            this.setState({
                notAcceptedEvaluators: responseJson.notAcceptedEvaluators
            })
        });
    }
    getRelations(product_id) {
        fetch(`${domainUrl}products/${product_id}?expand=relationship`, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 1) {
                this.setState({
                    relations: responseJson.data.relationship
                });
            }
        });
    }
    openEvaluatorModal() {
        this.setState({
            openModal: true
        })
    }
    closeEvaluatorModal() {
        this.setState({
            openModal: false
        })
    }
    showHide(ele, action = "show") {
        if (action === "show") {
            $(ele).show();
        } else {
            $(ele).hide();
        }
    }
    goWithSelfEvaluation() {
        this.setState({
            selfEvaluation: false,
            assesorEvaluation: false
        })
    }
    render() {
        const {
            data
        } = this.props;
        const relationShipHtml = this.state.relations.map((val, key) => {
            return <option key={`relation_${key}`} value={val.name}>{val.name}</option>
        });
        const questionHtml = this.state.questions.map((val, key) => {
            return <div key={`evaluation_question_${key}`} className="fdbk-questn">
                <span className="question_txt">
                    <div className="greenbg">{key+1}</div>
                    {
                        val.questionLabel
                    }
                    {
                        val.questionAnswer !== "" &&
                        <div className="analog-ans-bg">
                            <span style={{color: "#1e7bc0", fontWeight: "500"}}>Answer: </span>
                            <span style={{fontWeight: "400"}}>{val.questionAnswer}</span>
                        </div>
                    }
                    {
                        val.questionAnswer === "" &&
                        <Inputgenerator qDetails={val} />
                    }
                </span>
          </div>
        });
        const completedEvaluatorHtml = this.state.completedEvaluators.map((val, key) => {
            return <tr key={`completed_evaluator_${key}`} style={val.attribute}>
                <td align="center">{key+1}.</td>
                <td>{val.name}</td>
                <td>{val.date}</td>
                <td>{val.status}</td>
                <td align="center">
                    {
                        !val.isCompleted && val.canResend &&
                        <input type="button" className="button-accept mail-icon" title="Resend" value="Resend" onClick={()=>this.resendEvaluation(val.id, val.assessor_id)} />
                    }
                    {
                        !val.isCompleted && !val.canResend &&
                        <span>
                            <input type="button" className="button-accept mail-icon" title="Resend" value="Resend" onClick={()=>this.resendEvaluationNotify()} />
                            <input type="button" className="button-cancel" title="Withdraw" value="Withdraw" onClick={()=>this.withDrawEvaluation(val.id, val.assessor_id)} />
                        </span>
                    }
                    {
                        val.isCompleted &&
                        <span>--</span>
                    }
                </td>
            </tr>
        });
        const acceptedEvaluatorHtml = this.state.acceptedEvaluators.map((val, key) => {
            return <tr key={`accepted_evaluator_${key}`} style={val.attribute}>
                <td align="center"><input type="checkbox" name="evaluators" value={val.id} onClick={e=>handleCheckbox(e)} /></td>
                <td>{val.name}</td>
                <td>{val.relationship}</td>
                <td>{val.email}</td>
                <td>{val.phone}</td>
            </tr>
        });
        const notAcceptedEvaluatorHtml = this.state.notAcceptedEvaluators.map((val, key) => {
            return <tr key={`not_accepted_evaluator_${key}`} style={val.attribute}>
                <td>{val.name}</td>
                <td>{val.relationship}</td>
                <td>{val.email}</td>
                <td>{val.phone}</td>
                <td>{val.status}</td>
                <td align="center"><img src={process.env.PUBLIC_URL +"/images/mail_delete.gif"} width="14" height="14" alt="" border="0" style={{cursor: "pointer"}} onClick={e=>this.removeEvaluator(val.id)} /></td>
            </tr>
        });
        var timer, timerNote;
        if (this.state.componentStatus === "" && this.state.timeForCompletion > 0) {
            timer = <TimerCountDown seconds={this.state.timerSeconds} onComplete={(e)=>this.submitEvaluationForm()} />
            timerNote = <div className="ans-explanation"><b>To attend the next live session, you must complete this component in {this.state.timeForCompletion} minute(s).</b></div>
        }
        const evaluatorHtml = <div className="digitalquestion">
            {
                this.state.welcomeMessage !== "" &&
                <div className="dqmsg">{this.state.welcomeMessage}</div>
            }
            {
                this.state.selfEvaluation &&
                <div className="ans-explanation">
                    <h2>{this.state.questionType} by me</h2>
                    <div id="click">
                        {
                            !this.state.isLearnerAnswered &&
                            <a href="javascript:void(0);" className="button-blue1" title="Click here to enter" onClick={()=>this.goWithSelfEvaluation()}>Click here to enter</a>
                        }
                        {
                            this.state.isLearnerAnswered &&
                            <a href="javascript:void(0);" className="button-blue1" title="Click here to view my answers" onClick={()=>this.goWithSelfEvaluation()}>Click here to view my answers</a>
                        }
                    </div>
                </div>
            }
            {
                this.state.assesorEvaluation &&
                <div className="ans-explanation">
                    <h2 className="ppe">{this.state.questionType} by my Evaluators</h2>
                    {
                        this.state.completedAssessment < 15 &&
                        <div>
                            <div className="bold_black"><b>{this.state.questionType} Status</b></div>
                            <div className="msg_txt">Please note that atleast 2 Evaluators should evaluate this questionnaire.</div>
                            <div className="tbl_main" id="StatusAssessor">
                                <div className="tbl_brd_green">
                                    <table cellPadding="0" cellSpacing="0" border="1" style={{borderCollapse: "collapse"}} width="100%" id="tbl_brd_green">
                                        <thead>
                                            <tr id="tbl_head">
                                                <th></th>
                                                <th>Evaluator&#39;s Name</th>
                                                <th>Sent on</th>
                                                <th>Current Status</th>
                                                <th>Resend/Withdraw</th>
                                            </tr>
                                        </thead>
                                        <tbody>{completedEvaluatorHtml}</tbody>
                                    </table>
                                    {
                                        this.state.completedEvaluators.length === 0 &&
                                        <div className="manage-assessors-white">You have not sent the questionnaire to any Evaluator.</div>
                                    }
                                </div>
                                <div className="orange-border"></div>
                                <div className="uparrowcenter"><img src={process.env.PUBLIC_URL +"/images/uparrow.png"} alt="" width="35" height="34" border="0" /></div>
                            </div>
                        </div>
                    }
                    {
                        this.state.completedAssessment > 15 &&
                        <table cellPadding="0" cellSpacing="0" border="1" style={{borderCollapse: "collapse", border: "solid 1px #e7e7e7"}} width="100%">
                            <tbody>
                                <tr>
                                    <td>Completed by Evaluators <b>{this.state.completedEvaluatorNames}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    {
                        this.state.completedAssessment < 15 &&
                        <div>
                            <div className="bold_black"><b>Accepted Evaluators to choose from</b></div>
                            <div className="msg_txt">Please select the Evaluators from this list to send this questionnaire.</div>
                            <div className="tbl_main tbl_brd_blue">
                                <form id="SendEvaluator" action="#" method="POST">
                                <table cellPadding="0" cellSpacing="0" border="1" style={{borderCollapse: "collapse"}} width="100%">
                                    <thead>
                                        <tr id="tbl_head">
                                            <th></th>
                                            <th>Evaluator&#39;s Name</th>
                                            <th>Relationship</th>
                                            <th>Email ID</th>
                                            <th>Contact No</th>
                                        </tr>
                                    </thead>
                                    <tbody>{acceptedEvaluatorHtml}</tbody>
                                </table>
                                </form>
                                {
                                    this.state.acceptedEvaluators.length === 0 &&
                                    <div className="manage-assessors-white">
                                        There are no Active Evaluators. Please add new Evaluators to complete this evaluation.
                                    </div>
                                }
                                {
                                    this.state.acceptedEvaluators.length > 0 &&
                                    <div className="button">
                                        <input type="hidden" name="evaluators_hidden" ref="evaluators_hidden" className="required evaluator-block" />
                                        <input type="button" value="Send Evaluation" onClick={()=>this.sendEvaluation()} />
                                    </div>
                                }
                            </div>
                            <div className="bold_black orange-border1">
                                <b>Evaluators yet to accept</b>
                                <a href="javascript:void(0);" className="orgtxt button-blue1" title="Add new Evaluator" onClick={()=>this.openEvaluatorModal()}><b>Add new Evaluator</b></a>
                            </div>
                            <div className="msg_txt">
                                Please contact these Evaluators to get their acceptance.
                            </div>
                            <div className="tbl_main tbl_brd_gray" id="Awaitinglist">
                                <table cellPadding="0" cellSpacing="0" border="0" width="100%" id="tbl_brd_gray" style={{borderCollapse: "collapse", border: "solid 1px #0e63a2"}}>
                                    <thead>
                                        <tr id="tbl_head">
                                            <th>Evaluator&#39;s Name</th>
                                            <th>Relationship</th>
                                            <th>Email ID</th>
                                            <th>Contact No</th>
                                            <th>Status</th>
                                            <th align="center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>{notAcceptedEvaluatorHtml}</tbody>
                                </table>
                                {
                                    this.state.notAcceptedEvaluators.length === 0 &&
                                    <div className="manage-assessors-white">You have no pending Evaluators.</div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
        const componentHtml = <div className="noevalution">
            {
                this.state.componentStatus === "incompleted" &&
                <div>
                    <ThanksMessage message={this.state.statusMessage} />
                    <SelectLearnerObserver submitObserverandProceed={this.submitObserverandProceed} />
                </div>
            }
            {
                this.state.componentStatus === "" &&
                <div>
                    {
                        this.state.selfWelcomeMessage !== "" &&
                        <div className="slash_txtLP_dq" dangerouslySetInnerHTML={{__html:this.state.selfWelcomeMessage}} />
                    }
                    <div>
                        <span className="orgtxt noofques">Number of Questions : {this.state.noOfQuestions}</span>
                        <div className="ans-explanation">
                            <h3 className="score_explanation">Rating Explanation</h3>
                            <span dangerouslySetInnerHTML={{__html:this.state.scoringExplanation}} />
                        </div>
                        <div style={{height: "15px", clear: "both"}}></div>
                        <div id="rat_alg">
                            <div id="evaluation_form">
                                {
                                    timerNote
                                }
                                {
                                    questionHtml
                                }
                                {
                                      this.state.canRate &&
                                      <div className="ans-explanation">
                                          <span className="myrate">I would rate my efforts in actioning this component as <span className="txt-red">*</span></span>
                                          <span className="myrate-select">
                                              <select ref="rating" className="required" data-error-required="Please rate your performance">
                                                  <option value="">Select</option>
                                                  <option value="1">Poor ( 1 )</option>
                                                  <option value="2">Below Average ( 2 )</option>
                                                  <option value="3">Average ( 3 )</option>
                                                  <option value="4">Above Average ( 4 )</option>
                                                  <option value="5">Good ( 5 )</option>
                                                  <option value="6">Excellent ( 6 )</option>
                                                  <option value="7">Outstanding ( 7 )</option>
                                              </select>
                                          </span>
                                      </div>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        this.state.canAccessLR &&
                        <div style={{textAlign: "right"}}>
                            <input type="button" value="Submit" title="Submit" onClick={()=>this.submitEvaluationForm()} />
                        </div>
                    }
                </div>
            }
            {
                this.state.componentStatus === "completed" &&
                <div>
                    {
                        this.state.showCompletedMessage &&
                        <div className="ans-explanation success-msg">Successfully completed the Session.</div>
                    }
                    {
                        this.state.showAssessementTable &&
                        <AssessementViewList data={this.state.AssessementViewData} />
                    }
                    {
                        this.state.canRate &&
                        <div className="LERresult">My effort rating of this component is - <b>{this.state.rating} {this.state.ratingText}</b></div>
                    }
                    <span className="orgtxt noofques">Number of Questions : {this.state.noOfQuestions}</span>
                    <div id="rat_alg">
                        <div id="evaluation_form">{questionHtml}</div>
                    </div>
                    <div style={{clear: "both"}}></div>
                    {(this.props.usableType=="webapp")?<div style={{textAlign: "right"}}>
                        <input type="button" className="button_org" value="Continue" title="Continue" onClick={()=>this.goBackToComponentList()} />
                    </div>:""}
                </div>
            }
        </div>
        const centerHtml = <section id="semana-scroll-inner" className="scroll">
            <section className="viewport">
                <section className="overview" style={{top: "0px"}}>
                    <div className="inner-content">
                        {
                            (this.state.selfEvaluation || this.state.assesorEvaluation) &&
                            evaluatorHtml
                        }
                        {
                            !this.state.selfEvaluation && !this.state.assesorEvaluation &&
                            componentHtml
                        }
                    </div>
                </section>
            </section>
            <Modal open={this.state.openModal} onClose={()=>this.closeEvaluatorModal()}>
                <form id="addEvaluator" action="#" method="POST">
                    <table align="center" border="0" width="100%" cellPadding="5" cellSpacing="0">
                        <tbody>
                            <tr>
                                <td className="title_assessors" width="80%" colSpan="2">Evaluator Details</td>
                                <td width="15%">
                                    <div style={{padding: "0", textAlign: "right"}}></div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" height="35" valign="top">Please fill the details here for the new Evaluator.</td>
                            </tr>
                            <tr>
                                <td width="20%" valign="top" className="formlabel">Email ID</td>
                                <td>
                                    <input type="text" ref="email" className="txtbox required add-evl-block" onFocus={e=>this.showHide('#msgEmailChk')} onBlur={e=>this.showHide('#msgEmailChk', 'hide')} />
                                    <div id="msgEmailChk" className="errorObserver" style={{display: "none"}}>Please ensure that this Email ID is correct and active, as the Evaluator will receive communication on this ID only</div>
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle" className="formlabel">Name</td>
                                <td>
                                    <input type="text" ref="assessor_name" className="txtbox required add-evl-block" />
                                </td>
                            </tr>
                            <tr>
                                <td>Relationship</td>
                                <td>
                                    <select ref="relationship" className="required add-evl-block">
                                        {relationShipHtml}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>Gender</td>
                                <td>
                                    <input type="radio" value="1" name="gender" className="rdbtn" onClick={e=>handleRadio(e)} /> Male &nbsp;
                                    <input type="radio" value="0" name="gender" className="rdbtn" onClick={e=>handleRadio(e)} /> Female
                                    <input type="hidden" ref="gender_hidden" name="gender_hidden" className="required add-evl-block" />
                                </td>
                            </tr>
                            <tr>
                                <td valign="middle" className="formlabel">Contact No</td>
                                <td>
                                    <input type="text" ref="phone" maxLength="10" className="txtbox required add-evl-block" onKeyPress={e=>allowOnlyNumberInput(e)} />
                                </td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>
                                    <div className="dqbutton">
                                        <input type="button" title="Submit" value="Submit" className="button-accept" onClick={()=>this.addEvaluator()} /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <input type="button" title="Exit" value="Exit" className="button-cancel" onClick={()=>this.closeEvaluatorModal()} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </Modal>
        </section>
        return (<div>
      {
          this.state.agInfo !== "" &&
          <div>
              <div className="action_goals">
                  {timer}
                  <div className="img_action_goal"><img src={process.env.PUBLIC_URL +"/images/img_action_goal1.gif"} width="58" height="82" alt="Action Goal" title="Action Goal" border="0" /></div>
                  <div className="ag_title_arrow">{this.state.agInfo.name}</div><br />
                  <div className="slash_adAG">
                      <div className={data.spanclass} title={this.state.altText}></div>
                      <div className="pgad_txt"><span className="pgad_title">{this.state.questionaireName}</span></div>
                      <span className="lm_subtitle">{this.state.questionaireType}</span>
                  </div>
              </div>
              {centerHtml}
          </div>
      }
      {
          this.state.agInfo === "" &&
          <div className="main-inner">
              {timer}
              <div className="border-box">
              <div className={this.state.questionType?"title-box":"title-box tit-new"}>
                      <div className={`icon-box ${data.spanclass}`} title={this.state.altText}></div>
                      <h6>{this.state.questionName}</h6><span className="bluetxt">{this.state.questionType}</span>
                  </div>
                  {centerHtml}
              </div>
          </div>
      }
      </div>);
    }
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/EvaluationForm.js